export const ROOT = '/';
export const SIGNIN = '/signin';
export const DEMO = '/demo';
export const DEFAULT = '/default';
export const MY_ACCOUNT = '/my-account';
export const TRIPS = '/trips';
export const WORKFLOW = '/workflow';
